import React from 'react';
import Paper from '@material-ui/core/Paper';
import ReportIcon from '@material-ui/icons/Assessment';
import EditIcon from '@material-ui/icons/Edit';
import { reportItemStyles } from './styles';
import { useHistory } from 'react-router-dom';
import { TReport } from '../../../definitions';
import Grid from '@material-ui/core/Grid';

export default function ReportsItem({ report }: { report: TReport }) {
  const history = useHistory();
  const classes = reportItemStyles();

  return (
    <Paper
      className={classes.paper}
      elevation={0}
      onClick={() => history.push(`/reports/${report.id}/view`)}
    >
      <Grid container justify="space-between" alignItems="center">
        <Grid item>
          <Grid container alignItems="center">
            <ReportIcon fontSize="large" />
            <p className={classes.name}>{report.name}</p>
          </Grid>
        </Grid>
        <Grid item>
          <EditIcon fontSize="default" />
        </Grid>
      </Grid>
    </Paper>
  );
}
